import { GetNews, GetPolicy, GetTheme, Locale, LocaleItem, NewsDetailResponse } from '@core/app/types/globalApiType';
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const globalApi = createApi({
    reducerPath: 'globalApi',
    baseQuery: fetchBaseQuery({ 
        baseUrl: process.env.ENV === 'local' ? `${process.env.API_URL}/api` : `${window.location.origin}/api`,
        prepareHeaders: (headers) => {
            const token = document.getElementsByName('csrf-token')[0]?.getAttribute('content')
            if (token) headers.set('X-CSRF-TOKEN', token)

            const customCorporation = document.getElementById('__custom_route_data')?.getAttribute('data-corpId')
            if (customCorporation) headers.set('X-CORP-CONTEXT', customCorporation)

            return headers
        },
    

        credentials: process.env.ENV === 'local' ? 'include' : 'same-origin'
    }),
    tagTypes: ['Locale', 'InfoMessage'],
    endpoints: (builder) => ({
        getLocale: builder.query<Locale, void>({
            query: () => ({
                url: '/locale',
                method: 'GET',
            }),
            providesTags: ['Locale']
        }),
        changeLocale: builder.mutation<{statusCode: number, data: {current: LocaleItem}}, {data: {languageId: number}}>({
            query: (body) => ({
                url: '/locale/change',
                method: 'POST',
                body
            }),
            invalidatesTags: ['Locale']
        }),
        getTheme: builder.query<GetTheme, { preview_token?: string }>({
            query: ({ preview_token }) => {
                return {
                    url: `/theme`,
                    method: 'GET',
                    params: { preview_token }
                }
            },
         }),
        getPolicy: builder.query<GetPolicy, { type: string }>({
            query: ({ type }) => ({
                url: `/policy`,
                method: 'GET',
                params: { type }
            })
        }),
        getNews: builder.query<GetNews, { limit: number, page: number }>({
            query: ({ limit, page }) => `/newsfeed?limit=${limit}&page=${page}`,
        }),
        
        getNewsDetail: builder.query<NewsDetailResponse, string | number>({
            query: (newsId) => `/newsfeed/${newsId}`,
        }),

        getNewsDetailPreview: builder.query<NewsDetailResponse, { getParams: string | undefined }>({
            query: ({ getParams }) => ({
                url: `/newsfeed/preview${getParams}`,
                method: 'GET',
            }),
        }),
        getAllInfoMessages: builder.query<number[], void>({
            query: () => ({
                url: `/profile/info-message`,
                method: 'GET',
            }),
            transformResponse: (response: { data: { hideMessages: number[] } }) => {
                return response.data.hideMessages
            },
            providesTags: ['InfoMessage']
        }),
        postInfoMessage: builder.mutation<{ data: { hideMessages: number[] } }, { data: { infoMessageId: number } }>({
            query: (body) => ({
                url: `/profile/info-message/create/${body.data.infoMessageId}`,
                method: 'POST',
            }),
            invalidatesTags: ['InfoMessage']
        }),
        deleteInfoMessage: builder.mutation<void, void>({
            query: (body) => ({
                url: `/profile/info-message/delete`,
                method: 'DELETE',
            }),
        })
    }),
})

export const { useGetLocaleQuery, useChangeLocaleMutation, useGetThemeQuery, useGetPolicyQuery, useGetNewsQuery, useGetNewsDetailQuery, useGetNewsDetailPreviewQuery, useLazyGetAllInfoMessagesQuery, usePostInfoMessageMutation, useDeleteInfoMessageMutation } = globalApi